// schemaRenderer.tsx
'use client';

import Script from 'next/script';
import { ReactElement } from 'react';

interface SchemaRendererProps<T> {
    schemaData: T | null;
    id: string;
}

const SchemaRenderer = <T extends Record<string, unknown>>({
    schemaData,
    id,
}: SchemaRendererProps<T>): ReactElement | null => {
    if (!schemaData) return null;

    return (
        <Script
            id={`${id}-schema-data`}
            strategy='lazyOnload'
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
        />
    );
};

export default SchemaRenderer;
